import GuID from './helpers/guid';
import "babel-polyfill";

class Init {

    constructor() {

        this.guidInput = '';

        this.createGuid();
        this.initResizeFont();
    }

    createGuid() {

        $(document).ready(() => {
            GuID.generateGuID();
        });

    }

    initResizeFont() {
        $.fn.textWidth = function (text, font, size) {

            if ($.fn.textWidth.fakeEl) {
                $.fn.textWidth.fakeEl.remove();
            }

            $.fn.textWidth.fakeEl = $('<span>').hide().appendTo(document.body);
            $.fn.textWidth.fakeEl.text(text || this.val() || this.text()).css({
                fontSize: parseInt(size),
                fontFamily: font
            });

            const width = $.fn.textWidth.fakeEl.width();

            $.fn.textWidth.fakeEl.remove();

            return width;
        };
    }

}

export const init = new Init();
